/**
 * File Download Utility
 * Handles downloading files to the local file system.
 * Uses the File System Access API (showSaveFilePicker) if available,
 * otherwise falls back to a standard anchor tag download.
 */

export async function downloadMedia(
    blobOrUrl: Blob | string,
    defaultFilename: string,
    mimeType: string = 'video/mp4'
): Promise<void> {
    try {
        let blob: Blob;

        // Convert URL to Blob if needed
        if (typeof blobOrUrl === 'string') {
            const response = await fetch(blobOrUrl);
            blob = await response.blob();
        } else {
            blob = blobOrUrl;
        }

        // Try File System Access API (modern browsers)
        if ('showSaveFilePicker' in window) {
            try {
                const handle = await (window as any).showSaveFilePicker({
                    suggestedName: defaultFilename,
                    types: [{
                        description: 'Media File',
                        accept: { [mimeType]: ['.mp4', '.png', '.jpg', '.webp'] },
                    }],
                });
                const writable = await handle.createWritable();
                await writable.write(blob);
                await writable.close();
                return;
            } catch (err: any) {
                // User cancelled or API failed, fall back to default download
                if (err.name !== 'AbortError') {
                    console.warn('[Download] File picker failed or not supported, falling back to auto-download:', err);
                } else {
                    return; // User cancelled
                }
            }
        }

        // Fallback: Anchor tag download
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = defaultFilename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

    } catch (error) {
        console.error('[Download] Failed to download media:', error);
        alert('Erreur lors du téléchargement du fichier.');
    }
}
